import useDeleteParticipantRanking from 'entity/event/useDeleteParticipantRanking'
import useGetEventParticipantList from 'entity/event/useGetEventParticipantList'
import usePostParticipantAddOn from 'entity/event/usePostParticipantAddOn'
import usePostPrograde from 'entity/event/usePostPrograde'
import usePutParticipantRanking from 'entity/event/usePutParticipantRanking'
import {useNavigate} from 'react-router-dom'
import Search from 'widget/Search'
import TStyle from 'shared/style/tableStyle'
import Style from './style'
import DefaultButton from 'shared/ui/DefaultButton'
import {convertProGradeAsName} from 'shared/constant/lookup/proGrade'
import {OFFICIAL, TRYOUT} from 'shared/constant/lookup/eventType'
import Pagenation from 'widget/Pagenation'
import {useEffect, useState, useRef} from 'react'
import SortableHeader from 'shared/ui/SortableHeader'
import TableLoading from 'shared/ui/TableLoading'
import editIcon from 'shared/assets/ic_edit.svg'
import checkIcon from 'shared/assets/ic_check.svg'
import cancelIcon from 'shared/assets/ic_cancel.svg'
import useRoleCookie from 'shared/model/useRoleCookie'
import {
	ROLE_FRANCHISE_MANAGER,
	ROLE_STORE_MANAGER,
} from 'shared/constant/lookup/role'

const JoinedParticipantList = ({eventData, setAccountSelect, setTabCount}) => {
	const navigate = useNavigate()
	const [deleteRanking] = useDeleteParticipantRanking()
	const [postAddOn] = usePostParticipantAddOn()
	const [postProGrade] = usePostPrograde()
	const [eventParticipantList, isLoading, refetch] =
		useGetEventParticipantList()
	const [roleCookie] = useRoleCookie()

	const [editingRankId, setEditingRankId] = useState(null)
	const [rankValue, setRankValue] = useState('')
	const [rankError, setRankError] = useState('')
	const rankInputRef = useRef(null)

	const participantList = eventParticipantList?.data?.participant_list
	const maxPage = eventParticipantList?.data?.max_page
	const totalParticipants = eventParticipantList?.data?.total_participant

	const handleRankUpdateSuccess = () => {
		setEditingRankId(null)
		setRankValue('')
		setRankError('')

		if (refetch && typeof refetch === 'function') {
			refetch()
		}
	}

	const [putRanking] = usePutParticipantRanking(
		editingRankId,
		rankInputRef,
		handleRankUpdateSuccess
	)

	useEffect(() => {
		if (eventParticipantList?.data) {
			setTabCount({
				joined: eventParticipantList?.data?.total_participant ?? '0',
				notJoined: eventParticipantList?.data?.total_not_join ?? '0',
			})
		}
	}, [eventParticipantList?.data])

	const handleEditRank = (participantIdx, currentRank) => {
		setEditingRankId(participantIdx)
		setRankValue(currentRank || '')
		setRankError('')
		setTimeout(() => rankInputRef.current?.focus(), 0)
	}

	const handleCancelEdit = () => {
		setEditingRankId(null)
		setRankValue('')
		setRankError('')
	}

	const handleRankChange = (e) => {
		const value = e.target.value
		setRankValue(value)

		if (
			value &&
			(isNaN(value) ||
				parseInt(value) < 1 ||
				parseInt(value) > totalParticipants)
		) {
			setRankError(`순위는 1에서 ${totalParticipants} 사이여야 합니다`)
		} else {
			setRankError('')
		}
	}

	const handleSaveRank = () => {
		const trimmedValue = String(rankValue || '').trim()

		if (!trimmedValue || trimmedValue === '' || isNaN(trimmedValue)) {
			setRankError('유효한 순위를 입력해 주세요')
			return
		}

		if (rankError) {
			return
		}

		putRanking()
	}

	const handleNavigateToUser = (accountIdx, e) => {
		e.stopPropagation()
		navigate(`/user/${accountIdx}/detail`)
	}

	return (
		<>
			<Search
				placeholder='IDX, 이름, 별명, 연락처로 검색 가능'
				qualificationFilter={
					roleCookie !== ROLE_FRANCHISE_MANAGER &&
					roleCookie !== ROLE_STORE_MANAGER
				}
			/>

			<TableLoading isLoading={isLoading}>
				<TStyle.TableDiv>
					<TStyle.TableInner>
						<TStyle.TableRow $title>
							{tableHeadList.map((elem, index) => (
								<TStyle.Data key={index} $title $size={sizeList[index]}>
									<SortableHeader sortKey={elem.sortKey}>
										{elem.label}
									</SortableHeader>
								</TStyle.Data>
							))}
						</TStyle.TableRow>
						{participantList?.map((elem, index) => {
							const isEditing = editingRankId === elem?.idx
							const showError = isEditing && rankError

							return (
								<TStyle.TableRow
									key={index}
									$odd={index % 2 === 1}
									$cursor='default'
								>
									<TStyle.Data $size={sizeList[0]} $cursor='pointer'>
										<Style.RankingCell>
											{!isEditing ? (
												<Style.RankDisplay>
													<span>{elem?.ranking_display ?? '-'}</span>
													<Style.ImgEdit
														src={editIcon}
														alt='edit'
														onClick={() =>
															handleEditRank(elem?.idx, elem?.ranking_display)
														}
													/>
												</Style.RankDisplay>
											) : (
												<Style.EditForm>
													<Style.RankInput
														ref={rankInputRef}
														type='number'
														value={rankValue}
														onChange={handleRankChange}
														$rankError={rankError ? true : false}
														min='1'
														max={totalParticipants}
													/>
													<img
														src={checkIcon}
														alt='save'
														className='action-icon'
														onClick={handleSaveRank}
													/>
													<img
														src={cancelIcon}
														alt='cancel'
														className='action-icon'
														onClick={handleCancelEdit}
													/>
												</Style.EditForm>
											)}
											{showError && (
												<Style.ErrorMessage>{rankError}</Style.ErrorMessage>
											)}
										</Style.RankingCell>
									</TStyle.Data>
									<TStyle.Data $size={sizeList[1]}>{elem?.idx}</TStyle.Data>
									<TStyle.Data
										$size={sizeList[2]}
										onClick={(e) => handleNavigateToUser(elem?.account_idx, e)}
										$cursor='pointer'
									>
										{elem?.account_idx}
									</TStyle.Data>
									<TStyle.Data
										$size={sizeList[3]}
										onClick={(e) => handleNavigateToUser(elem?.account_idx, e)}
										$cursor='pointer'
									>
										{elem?.name}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[4]}>
										{elem?.nickname}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[5]}>
										+{elem?.international_number} {elem?.contact}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[6]}>
										{convertProGradeAsName[elem?.pro_grade_flag]}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[7]}>
										{elem?.re_entry_count}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[8]}>
										{elem?.is_early ? 'Yes' : ''}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[9]}>
										{elem?.is_add_on ? 'Yes' : ''}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[10]} $align='right'>
										{elem?.leaving_time === null &&
											!elem?.has_used_addon_before && (
												<DefaultButton
													small
													fitWidth
													clickEvent={(e) => {
														e.stopPropagation()
														postAddOn(elem?.account_idx)
													}}
												>
													에드온 +
												</DefaultButton>
											)}

										<DefaultButton
											small
											fitWidth
											clickEvent={(e) => {
												e.stopPropagation()
												deleteRanking(elem?.idx)
											}}
										>
											탈락 취소
										</DefaultButton>
										{[OFFICIAL].includes(eventData?.data?.event_type_flag) && (
											<DefaultButton
												small
												fitWidth
												clickEvent={(e) => {
													e.stopPropagation()
													setAccountSelect(elem?.account_idx)
												}}
											>
												시드권 지급
											</DefaultButton>
										)}
										{[TRYOUT].includes(eventData?.data?.event_type_flag) && (
											<DefaultButton
												small
												fitWidth
												clickEvent={(e) => {
													e.stopPropagation()
													postProGrade(elem?.account_idx)
												}}
											>
												프로 자격 부여
											</DefaultButton>
										)}
									</TStyle.Data>
								</TStyle.TableRow>
							)
						})}
					</TStyle.TableInner>
				</TStyle.TableDiv>
			</TableLoading>

			<Pagenation maxPage={maxPage} />
		</>
	)
}

export default JoinedParticipantList

const sizeList = [
	'mediumUp',
	'medium',
	'medium',
	'medium',
	'medium',
	'long',
	'medium',
	'long',
	'medium',
	'medium',
	'expand',
]
const tableHeadList = [
	{label: '순위', sortKey: 'rank'},
	{label: '참가 IDX', sortKey: 'idx'},
	{label: '사용자 IDX', sortKey: 'account_idx'},
	{label: '이름', sortKey: 'name'},
	{label: '닉네임', sortKey: 'nickname'},
	{label: '연락처', sortKey: 'contact'},
	{label: '프로 자격', sortKey: 'pro_grade_flag'},
	{label: '리엔트리 횟수', sortKey: 're_entry_count'},
	{label: '얼리 여부', sortKey: 'is_early'},
	{label: '에드온 여부', sortKey: 'is_add_on'},
	{label: ''},
]
